import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import InOutResultContext from './InOutResultContext';
import InOutResultApi from './InOutResultApi';
import InOutResultService from './InOutResultService';
import FieldSettingsApi from '../fieldSettings/FieldSettingsApi';
import FieldTreeWorkersApi from '../fieldTreeWorkers/FieldTreeWorkersApi';
import WorkerSettingsApi from '../workerSettings/WorkerSettingsApi';
import WorkerSettingsService from '../workerSettings/WorkerSettingsService';

import LocalStorageService from '../utilities/LocalStorageService';
import SessionStorageService from '../utilities/SessionStorageService';
import { messageUtility } from '../../utilities/messageUtility';
import DocumentDelegate from '../../utilities/DocumentDelegate';
import { DropdownCalendarLoader } from '../../utilities/formComponents';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  blobToJsonConversion,
  extractErrorMessage,
} from '../../utilities/commonUtil';
import {
  APPROVED_STATUS,
  DATE_TIME_FORMAT,
  DEFAULT_IN_OUT_RESULT_TIME,
  DIALOG_STATUS,
  CCUS_SENT_STATUS,
  RADIO_BUTTON,
  RECORDING_METHOD,
  SORT_TYPE,
  ROAN_STATUS,
  USE_CCUS_ENGINEER_ID,
  ENTRANCE_WORKER_TYPES,
  USER_ROLES,
  ENTRANCE_EXIT_RECORD_STATUS,
  CALL_FROM_PAGE,
  API_FLAG,
} from '../../utilities/constants';
import { isTargetRoleId } from '../../utilities/roleUtility';
import Joi from 'joi-browser';
import { validationByJoi } from '../../utilities/commonValidation';

const TITLE_NOT_CHOICE_RECORD = '変更可能な項目が選択されていません';
/**
 * 入退場実績のstate管理用コンポーネント
 * */
export default class InOutResultStore extends React.Component {
  state = {
    isLoading: true, // API等でローディング中フラグ
    canLoadMore: true,
    editFormClearFlag: false,
    isShowNotExistFieldIdDialog: false, // 現場IDの存在チェックフラグ
    fieldSettings: Object.create(null), // 現場設定情報
    fieldId: '',
    roleId: LocalStorageService.getRoleId(),
    bodyTemperatureExists: 0,
    manualBodyTemperatureExists: 0,
    lastRequestWithTemperature: false,
    checkInOutLogList: [], // 入退場実績一覧
    fieldTreeList: [],
    workerList: [],
    selectedApproveCheckInOutLogList: [], // 選択された未承認の入退場実績一覧
    selectedUnapprovedCheckInOutLogList: [], // 選択された承認済の入退場実績一覧
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    previousDialogStatus: false, //作業員一覧画面中に見えてないダイアログ（追加・更新）
    errorDialogStatus: DIALOG_STATUS.disabled.id, // エラーダイアログ表示用ステータス > state.dialogStatusにエラーダイアログを設定すると呼び出し元のダイアログが廃棄されるため通信エラー用のフラグを用意
    isPrimeContractor: isTargetRoleId(
      [USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.manager],
      LocalStorageService.getRoleId()
    ), // true: 元請ユーザー, false: 協力会社ユーザー
    spotFlg: false,
    searchForm: {
      // 検索フォーム用プロパティ
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      fromDate: '', // 期間開始日
      toDate: '', // 期間終了日
      selectedApprovedStatus: '', // 承認状態
      workerName: '', // 作業員名
      selectedSentStatus: '', // 送信状態 (0:区別なし、1:入場、2:退場)
      ccusJigyousyaDeleted: '', //CCUS事業者ID削除フラグ
      fieldTreeIds: [], // 所属会社IDリスト,
      bodyTemperatureEnabled: false, // 体温フィルターのトグル
      bodyTemperature: '', // 体温
      order: '', // ソート項目
      sortType: '',
      isOpened: false, // 検索フォームトグルの開閉フラグ,
      priorCcusError: false,
      workerTypesList: [],
      primaryCompanyIds: [],
      entranceExitRecordStatus: [],
      clearFlag: false, //セレクトボックス検索条件クリアフラグ
    },
    infiniteScrollLoadSearchForm: {
      // 検索フォーム用プロパティ
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      fromDate: '', // 期間開始日
      toDate: '', // 期間終了日
      selectedApprovedStatus: '', // 承認状態
      workerName: '', // 作業員名
      selectedSentStatus: '', // 送信状態 (0:区別なし、1:入場、2:退場)
      fieldTreeIds: [], // 所属会社IDリスト,
      bodyTemperatureEnabled: false, // 体温フィルターのトグル
      bodyTemperature: '', // 体温
      order: '', // ソート項目
      sortType: '',
      isOpened: false, // 検索フォームトグルの開閉フラグ,
      priorCcusError: false,
      workerTypesList: [],
      primaryCompanyIds: [],
      entranceExitRecordStatus: [],
    },
    workerSelectDialog: {
      // 作業員一覧用ブロパティ
      total: 0, // 検索件数
      searchForm: {
        workerName: '', // 作業員名（検索条件）
        fieldTreeIds: [], // 協力会社（検索条件）
        isDistinct: true, // 重複作業員を表示しない
      },
      selectWorkerName: '', // 選択した作業員名
      selectWorkerId: '',
      listMessage: '',
      searchBoxClearFlag: false, // セレクトボックス検索条件クリアフラグ
    },
    editForm: {
      // 追加・更新用プロパティ
      workerType: 0,
      spotCompanyName: '',
      primeCompanyName: '',
      checkInOutLogId: '', // 入退場実績ID
      fieldTreeWorkerId: '', // 施工体制に割り当てられた作業員のID
      workerId: '', // 作業員自体のID
      workerName: '', // 作業員の名前
      recordingMethod: '', // 記録方法 0:入場のみ、1:入退場
      targetDate: '', // 出勤対象日
      inHour: DEFAULT_IN_OUT_RESULT_TIME.in.hour, // 入場時刻
      inMin: DEFAULT_IN_OUT_RESULT_TIME.in.min, // 入場分
      outHour: DEFAULT_IN_OUT_RESULT_TIME.out.hour, // 退場時刻
      outMin: DEFAULT_IN_OUT_RESULT_TIME.out.min, // 退場分
      nextFlg: 0, // 日跨ぎフラグ
      selectedOrder: null, // 追加画面の会社の次数を選択しているindex番号
      selectedFieldTree: Object.create(null), // 現場設定情報
      positionCode: '', // 立場コード
      positionName: '', // 立場名称
      categoryMajorCode: '', // 職種大分類コード
      categoryMajorName: '', // 職種大分類名称
      categoryMinorCode: '', // 職種小分類コード
      categoryMinorName: '', // 職種小分類名称
      workContent: '', // 作業内容
      displayFieldTree: '',
      blockedOn: '', // 作業員停止フラグ
      bodyTemperature: '', // 機器計測体温
      manualBodyTemperature: '', // 手入力体温
      remarks: '', // 備考
      manualUpdateUser: '', // 手動最終更新ユーザー
      manualUpdateAt: '', // 手動最終更新日時
      isValid: true, //バリデーションフラグ,
      errorList: {}, //バリデーションエラーリスト
    },
    failDialog: {
      message: '',
      title: '',
    },
    fieldTreeBranchSearchForm: {
      // 検索フォーム用プロパティ
      total: 0, // 検索結果件数
      offset: 0, // 検索時の初期件数
      name: '', // 氏名
      deduplicationflag: 0, // 重複を排除しない
      primaryDisplayFlag: 1, // 表示形式を「1次協力会社（自社）」にする
    },
    apiData: {
      spot_worker_name: '',
      worker_types: null,
    },
    ccusSecededWarning: false,
    jvFlag: false,
  };

  /**
   * 追加・更新用プロパティのバリデーションチェック
   * */
  validateEditForm = () => {
    let editFormState = { ...this.state.editForm };
    const valid = validationByJoi(this.editFormValidationScheme, editFormState);
    editFormState.isValid = valid.status;
    if (valid.status === false) {
      editFormState.errorList = valid.messages;
    } else {
      editFormState.errorList = {};
    }
    this.setState({ editForm: editFormState });
  };

  /**
   * 現場情報が存在しないエラーダイアログを閉じる
   * */
  closeNotExistFieldIdDialog = () => {
    let state = { ...this.state };
    state.isShowNotExistFieldIdDialog = false;
    this.setState(state);
  };

  /**
   * 検索フォームの開閉トグル
   * @param {string}propertyName:ステート内のプロパティ名
   * */
  searchFormHandle = propertyName => {
    let state = { ...this.state };
    state[propertyName].isOpened = !state[propertyName].isOpened;
    this.setState(state);
  };

  /**
   * 検索フォームの承認状態を選択
   * @param {object}event:選択された承認状態
   * */
  selectedApprovedStatus = event => {
    let state = { ...this.state };
    state[event.target.name].selectedApprovedStatus = event.target.value;
    this.setState(state);
  };

  /**
   * 検索フォームの作業員名を入力
   * @param {object}event:入力された作業員名
   * */
  inputWorkerName = event => {
    let state = { ...this.state };
    state[event.target.name].workerName = event.target.value;
    this.setState(state);
  };

  /**
   * 検索
   */
  doSearch = () => {
    let state = _.cloneDeep(this.state);
    state = this.clearListInfo(state);
    state.canLoadMore = true;
    state.infiniteScrollLoadSearchForm = _.cloneDeep(state.searchForm);
    this.setState(state, () => {
      this.loadCheckInOutResultList();
    });
  };

  /**
   * 検索フォームの送信状態を選択
   * @param {object}event:選択された送信状態
   * */
  selectedSentStatus = event => {
    let state = { ...this.state };
    state[event.target.name].selectedSentStatus = event.target.value;
    this.setState(state);
  };

  /**
   * 検索フォームの所属会社IDを選択
   * @param {number[]} fieldTreeIds 選択された所属会社IDリスト
   * */
  selectedFieldTreeIds = fieldTreeIds => {
    let searchForm = _.cloneDeep(this.state.searchForm);
    searchForm.fieldTreeIds = fieldTreeIds;
    this.setState({ searchForm });
  };

  /**
   * 入退場利用者を選択する
   * @param {object} worker 入退場利用者
   * */
  selectedWorker = worker => {
    const editForm = _.cloneDeep(this.state.editForm);
    editForm.workerId = worker.entrance_worker_id;
    editForm.workerName = worker.fullname;
    editForm.spotCompanyName = worker.spot_company_name;
    editForm.primeCompanyName = worker.prime_company_name;
    editForm.editFormClearFlag = false;
    this.setState({
      editForm,
    });
  };

  /**
   * 検索フォームの体温トグルの活性状態変更
   * @param {boolean} bodyTemperatureEnabled 活性状態を変更された体温トグル
   * */
  selectedBodyTemperatureEnabled = bodyTemperatureEnabled => {
    let searchForm = _.cloneDeep(this.state.searchForm);
    searchForm.bodyTemperatureEnabled = bodyTemperatureEnabled;
    this.setState({ searchForm });
  };

  /**
   * 検索フォームの体温を選択
   * @param {string}} bodyTemperature 選択された体温
   * */
  selectedBodyTemperature = bodyTemperature => {
    let searchForm = _.cloneDeep(this.state.searchForm);
    searchForm.bodyTemperature = bodyTemperature;
    this.setState({ searchForm });
  };

  /**
   * 検索フォームのCCUSエラーを優先するフラグのトグル
   * @param {string}} priorCcusError 選択された値
   * */
  selectedPriorCcusError = priorCcusError => {
    let state = _.cloneDeep(this.state);
    state.searchForm.priorCcusError = priorCcusError;
    state = this.clearListInfo(state);
    state.infiniteScrollLoadSearchForm.priorCcusError = priorCcusError;
    this.setState(state, () => {
      this.loadCheckInOutResultList();
    });
  };

  selectCompanyIds = companyIds => {
    const { searchForm } = this.state;
    this.setState({
      searchForm: {
        ...searchForm,
        primaryCompanyIds: companyIds,
      },
    });
  };

  checkSingleData = (propertyName, item) => {
    if (!_.has(item, 'id') && !_.has(item, 'ID')) {
      return;
    }
    const searchForm = _.cloneDeep(this.state.searchForm);
    const isUnchecking =
      !_.isEmpty(searchForm[propertyName]) &&
      _.some(searchForm[propertyName], item);
    searchForm[propertyName] = isUnchecking
      ? searchForm[propertyName].filter(value => !_.isEqual(value, item))
      : [...searchForm[propertyName], item];
    this.setState({ searchForm });
  };

  /**
   * 検索条件をクリアする
   * @param {string}propertyName:ステート内のプロパティ名
   * */
  clearSearchProperty = propertyName => {
    let state = { ...this.state };
    state[propertyName].clearFlag = true;
    state[propertyName].selectedApprovedStatus = '';
    state[propertyName].workerName = '';
    state[propertyName].selectedSentStatus = '';
    state[propertyName].fieldTreeIds = [];
    state[propertyName].bodyTemperatureEnabled = false;
    state[propertyName].bodyTemperature =
      state.fieldSettings.body_temperature_threshold || '';
    state[propertyName].order = '';
    state[propertyName].sortType = '';
    state[propertyName].workerTypesList = _.map(ENTRANCE_WORKER_TYPES, item => {
      if (
        state.spotFlg ||
        (!state.spotFlg && item.id === ENTRANCE_WORKER_TYPES.worker.id)
      ) {
        return item;
      }
    });
    state[propertyName].primaryCompanyIds = [];
    state[propertyName].entranceExitRecordStatus = _.map(
      ENTRANCE_EXIT_RECORD_STATUS,
      status => status
    );
    state = this.clearListInfo(state);
    state.infiniteScrollLoadSearchForm = _.cloneDeep(state.searchForm);
    state.searchForm.workerTypesList = _.map(ENTRANCE_WORKER_TYPES, item => {
      if (
        state.spotFlg ||
        (!state.spotFlg && item.id === ENTRANCE_WORKER_TYPES.worker.id)
      ) {
        return item;
      }
    });
    this.setState(state, this.loadCheckInOutResultList);
  };

  /**
   * 無限スクロールから呼び出される
   * @param {function}notify
   * */
  infiniteScrollLoad = async notify => {
    const { isLoading, canLoadMore } = _.cloneDeep(this.state);

    if (isLoading) {
      notify();
      return;
    }

    if (canLoadMore) {
      await this.loadCheckInOutResultList();
      notify();
    } else {
      notify('end');
    }
  };

  /**
   * チェックボックス1件更新
   * @param {object}item:1件のオブジェクト(選択した入退場実績)
   * */
  checkSingleTableData = item => {
    if (!item.hasOwnProperty('id')) {
      return;
    }

    let state = { ...this.state };
    if (item.approved_flg === APPROVED_STATUS.approved.id) {
      if (_.includes(state.selectedApproveCheckInOutLogList, item)) {
        _.pull(state.selectedApproveCheckInOutLogList, item);
      } else {
        state.selectedApproveCheckInOutLogList.push(item);
      }
    } else if (item.approved_flg === APPROVED_STATUS.unapproved.id) {
      if (_.includes(state.selectedUnapprovedCheckInOutLogList, item)) {
        _.pull(state.selectedUnapprovedCheckInOutLogList, item);
      } else {
        state.selectedUnapprovedCheckInOutLogList.push(item);
      }
    }
    this.setState(state);
  };

  /**
   * チェックボックス1件更新
   * @param {string}propertyName:ステート内のプロパティ名
   * @param {object}item:1件のオブジェクト(選択した項目)
   * */
  checkSingleSearchData = (propertyName, item) => {
    if (!item.hasOwnProperty('id') && !item.hasOwnProperty('ID')) {
      return;
    }

    const searchForm = _.cloneDeep(this.state.searchForm);
    if (searchForm[propertyName].length > 0) {
      if (_.some(searchForm[propertyName], item)) {
        searchForm[propertyName] = searchForm[propertyName].filter(
          value => !_.isEqual(value, item)
        );
      } else {
        searchForm[propertyName].push(item);
      }
    } else {
      searchForm[propertyName].push(item);
    }
    this.setState({
      searchForm,
    });
  };

  /**
   * @description 期間設定
   * @param {string} name フォーム名
   * @param {string} value 選択期間
   */
  changeSearchDate = (name, value) => {
    let state = { ...this.state };
    const originalDate = state.searchForm[name];
    state.searchForm[name] = moment(value).format(
      DATE_TIME_FORMAT.slashDateFormat
    );

    const switchFLag = moment(state.searchForm.toDate)
      .subtract(1, 'month')
      .isAfter(state.searchForm.fromDate);

    if (name === 'fromDate') {
      if (moment(state.searchForm.fromDate).isAfter(state.searchForm.toDate)) {
        state.searchForm.toDate = moment(state.searchForm.fromDate).format(
          DATE_TIME_FORMAT.slashDateFormat
        );
      } else if (
        switchFLag &&
        moment(state.searchForm.fromDate).isBefore(originalDate)
      ) {
        state.searchForm.toDate = moment(state.searchForm.fromDate)
          .add(1, 'month')
          .format(DATE_TIME_FORMAT.slashDateFormat);
      }
    } else if (name === 'toDate') {
      if (moment(state.searchForm.fromDate).isAfter(state.searchForm.toDate)) {
        state.searchForm.fromDate = moment(state.searchForm.toDate).format(
          DATE_TIME_FORMAT.slashDateFormat
        );
      } else if (
        switchFLag &&
        moment(state.searchForm.toDate).isAfter(originalDate)
      ) {
        state.searchForm.fromDate = moment(state.searchForm.toDate)
          .subtract(1, 'month')
          .format(DATE_TIME_FORMAT.slashDateFormat);
      }
    }

    state = this.clearListInfo(state);
    state.infiniteScrollLoadSearchForm.fromDate = state.searchForm.fromDate;
    state.infiniteScrollLoadSearchForm.toDate = state.searchForm.toDate;
    this.setState(state, () => {
      this.loadCheckInOutResultList();
    });
  };

  /**
   * 施工体系選択イベント
   * @param {object}fieldTreeIds
   * */
  selectFieldTree = fieldTreeIds => {
    let state = { ...this.state };
    state.workerSelectDialog.searchForm.fieldTreeIds = fieldTreeIds;
    this.setState(state);
  };

  /**
   * 作業員選択イベント
   * @param {array}event
   * */
  changeWorkerName = event => {
    let state = { ...this.state };
    state.workerSelectDialog.searchForm.workerName = event.target.value;
    this.setState(state);
  };

  /**
   * ソート
   * @param {string}sortName:ソートしたい名前
   * */
  changeSort = sortName => {
    let state = { ...this.state };
    if (state.searchForm.sortType === SORT_TYPE.asc.id) {
      state.searchForm.sortType = SORT_TYPE.desc.id;
    } else {
      state.searchForm.sortType = SORT_TYPE.asc.id;
    }

    if (state.searchForm.order !== sortName) {
      state.searchForm.order = sortName;
      state.searchForm.sortType = SORT_TYPE.asc.id;
    }
    state = this.clearListInfo(state);
    state.infiniteScrollLoadSearchForm.order = state.searchForm.order;
    state.infiniteScrollLoadSearchForm.sortType = state.searchForm.sortType;
    this.setState(state, this.loadCheckInOutResultList);
  };

  /**
   * ON/OFF制御
   * @param {string}propertyName:ステート内のプロパティ名
   * */
  toggle = propertyName => {
    let state = { ...this.state };
    if (state.editForm[propertyName] === RADIO_BUTTON.On) {
      state.editForm[propertyName] = RADIO_BUTTON.Off;
    } else if (state.editForm[propertyName] === RADIO_BUTTON.Off) {
      state.editForm[propertyName] = RADIO_BUTTON.On;
    }
    this.setState(state);
  };

  /**
   * 協力会社選択モーダルでの会社名の選択
   */
  changeSelectedOrder = order => {
    let state = { ...this.state };
    state.editForm.selectedOrder = order;
    this.setState(state);
  };

  /**
   * 協力会社選択モーダルで選択ボタンを押下
   */
  selectedFieldTree = () => {
    let state = { ...this.state };
    if (isNullOrEmpty(state.editForm.selectedOrder)) {
      return;
    }

    state.workerList.length = 0;
    state.editForm.fieldTreeWorkerId = '';
    state.editForm.selectedFieldTree = _.find(
      state.fieldTreeList[state.editForm.selectedOrder].trees,
      fieldTree => {
        return (
          fieldTree.id ===
          state.fieldTreeList[state.editForm.selectedOrder].selectTreeId
        );
      }
    );
    state.editForm.isCompanySelectDialogShow = false;
    this.setState(state);
    this.loadAssignedWorker(
      state.fieldTreeList[state.editForm.selectedOrder].selectTreeId
    );
  };

  /**
   * 協力会社選択モーダルでの作業員の選択
   */
  changeWorker = fieldTreeWorker => {
    let state = { ...this.state };
    state.editForm.fieldTreeWorkerId = fieldTreeWorker.id;
    state.editForm.workerId = state.workerSelectDialog.selectWorkerId;
    state.editForm.workerName = state.workerSelectDialog.selectWorkerName;
    state.editForm.displayFieldTree = this.displayFieldTreeRoute(
      fieldTreeWorker
    );
    state.dialogStatus = state.previousDialogStatus;
    state.isLoading = false;
    state.workerList.length = 0;
    state.fieldTreeList.length = 0;
    state.workerSelectDialog.total = 0;
    state.workerSelectDialog.searchForm.fieldTreeIds = [];
    state.workerSelectDialog.searchForm.workerName = '';
    state.workerSelectDialog.searchBoxClearFlag = !state.workerSelectDialog
      .searchBoxClearFlag;
    this.setState(state);
    this.settingWorkerContent(state);
  };

  /**
   * 作業員一覧を取得する
   * */
  searchWorkerList = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);

    let params = WorkerSettingsService.createSearchWorkerSettingList(
      state.workerSelectDialog.searchForm
    );
    params.call_from = CALL_FROM_PAGE.IN_OUT_RESULT_PAGE;

    WorkerSettingsApi.fetchWorkerSettingList(state.fieldId, params)
      .then(response => {
        if (response.result) {
          state.workerSelectDialog.total = response.data.total;
          state.workerList = response.data.entities.worker_settings;
          if (state.workerSelectDialog.total === 0) {
            state.workerSelectDialog.listMessage = messageUtility.getMessage(
              'I-000-046'
            );
          }
        } else {
          state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
        }
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 作業員労安データを取得し、入力項目に反映する
   */
  settingWorkerContent = state => {
    // 労務安全利用するかつfieldTreeWorkerIdが存在する場合
    if (
      ROAN_STATUS.on.id === Number(SessionStorageService.getUseRoanFlag()) &&
      !isNullOrEmpty(state.editForm.fieldTreeWorkerId)
    ) {
      // 表示中の労安データを初期化する
      state.editForm.categoryMajorCode = '';
      state.editForm.categoryMajorName = '';
      state.editForm.categoryMinorCode = '';
      state.editForm.categoryMinorName = '';
      state.editForm.positionCode = '';
      state.editForm.positionName = '';
      state.editForm.workContent = '';

      // 労安情報取得APIを呼出す
      FieldTreeWorkersApi.fetchWorkerInfo(
        state.fieldId,
        state.editForm.fieldTreeWorkerId
      )
        .then(response => {
          if (response.result === true && response.data.total > 0) {
            let workerInfo = response.data.entities.worker_info;
            state.editForm.positionCode = workerInfo.position_code;
            state.editForm.positionName = workerInfo.position_name;
            state.editForm.workContent = workerInfo.work_content;
            let jobCategories = workerInfo.job_categories;
            if (!_.isEmpty(jobCategories)) {
              state.editForm.categoryMajorCode = jobCategories[0].major_code;
              state.editForm.categoryMajorName = jobCategories[0].major_name;
              state.editForm.categoryMinorCode = jobCategories[0].minor_code;
              state.editForm.categoryMinorName = jobCategories[0].minor_name;
            }
          }
        })
        .finally(() => {
          this.setState(state);
        });
    }
  };

  /**
   * 更新モーダルの施工体制を変更
   * @param {number}fieldTreeWorkerId
   * */
  changeEditFormFieldTreeWorker = fieldTreeWorkerId => {
    let state = { ...this.state };
    state.editForm.fieldTreeWorkerId = fieldTreeWorkerId;
    this.setState(state);
  };

  /**
   * 入退場実績追加ダイアログを表示する
   * */
  showAddDialog = () => {
    let state = { ...this.state };
    state = this.clearEditFormInState(state);
    state.dialogStatus = DIALOG_STATUS.registerDialogEnabled.id;
    state.editForm.targetDate = moment().format(
      DATE_TIME_FORMAT.slashDateFormat
    );
    if (
      state.fieldSettings.recording_method ===
      RECORDING_METHOD.entranceAndExit.id
    ) {
      state.editForm.recordingMethod = state.fieldSettings.recording_method;
    }
    this.setState(state);
  };

  /**
   * 作業員一覧モーダル表示イベント
   * */
  showSelectWorkerDialog = () => {
    let state = { ...this.state };
    state.previousDialogStatus = state.dialogStatus;
    this.setState(state, () => {
      state.dialogStatus = DIALOG_STATUS.isWorkerSelectDialogShow.id;
      state.workerSelectDialog.listMessage = messageUtility.getMessage(
        'I-002-006-17'
      );
      this.setState(state);
    });
  };

  /**
   * 作業員一覧&施工体系選択ダイアログを閉じる
   * */
  closeWorkerSelectDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = state.previousDialogStatus;
    state.workerList.length = 0;
    state.fieldTreeList.length = 0;
    state.workerSelectDialog.total = 0;
    state.workerSelectDialog.searchForm.fieldTreeIds = [];
    state.workerSelectDialog.searchForm.workerName = '';
    state.workerSelectDialog.searchBoxClearFlag = !state.workerSelectDialog
      .searchBoxClearFlag;
    this.setState(state);
  };

  /**
   * 作業員一覧に戻るイベント
   * */
  backWorkerSelectDialog = () => {
    let state = { ...this.state };
    state.workerList.length = 0;
    state.fieldTreeList.length = 0;
    state.workerSelectDialog.total = 0;
    state.workerSelectDialog.searchForm.fieldTreeIds = [];
    state.workerSelectDialog.searchForm.workerName = '';
    state.workerSelectDialog.searchBoxClearFlag = !state.workerSelectDialog
      .searchBoxClearFlag;
    state.dialogStatus = DIALOG_STATUS.isWorkerSelectDialogShow.id;
    state.workerSelectDialog.listMessage = messageUtility.getMessage(
      'I-002-006-17'
    );
    this.setState(state);
  };

  /**
   * 作業員一覧モーダルの検索条件をクリア
   * */
  clearWorkerSelectSearchData = () => {
    let state = { ...this.state };
    state.workerSelectDialog.searchForm.fieldTreeIds = [];
    state.workerSelectDialog.searchForm.workerName = '';
    state.workerSelectDialog.searchBoxClearFlag = !state.workerSelectDialog
      .searchBoxClearFlag;
    this.setState(state);
  };

  /**
   * 入退場実績追加・更新ダイアログを閉じるに設定する
   * */
  closeEditDialog = () => {
    let state = { ...this.state };
    state = this.clearEditFormInState(state);
    this.setState(state);
  };

  /**
   * エラーメッセージを対応する
   * @param {object} error エラー
   */
  invokeError = error => {
    const state = _.cloneDeep(this.state);
    state.failDialog.message = extractErrorMessage(error);
    state.errorDialogStatus = DIALOG_STATUS.networkErrorDialogEnabled.id;
    state.isLoading = false;
    this.setState(state);
  };

  /**
   * 入退場実績削除ダイアログを表示するか確認する
   * */
  showDeleteDialogIfValid = () => {
    let state = { ...this.state };
    if (
      state.selectedApproveCheckInOutLogList.length > 0 ||
      state.selectedUnapprovedCheckInOutLogList.length > 0
    ) {
      state.dialogStatus = DIALOG_STATUS.deleteDialogEnabled.id;
    } else {
      state.failDialog.message = messageUtility.getMessage('W-002-001-002');
      state.failDialog.title = TITLE_NOT_CHOICE_RECORD;
      state.dialogStatus = DIALOG_STATUS.deleteFailDialogEnabled.id;
    }
    this.setState(state);
  };

  /**
   * 入退場実績更新ダイアログを表示する
   * @param {object}inOutResult:1件のオブジェクト(選択した入退場実績)
   * */
  showEditDialog = inOutResult => {
    let state = { ...this.state };
    state = this.clearEditFormInState(state);
    // BLDE_V2-50226 CCUS事業者IDは削除された場合に、ダイアログの送信ステータスを変更する
    let ccusSentStatus = inOutResult.ccus_send_status;
    if (
      inOutResult.ccus_send_status === CCUS_SENT_STATUS.unsent.id &&
      inOutResult.ccus_jigyousya_deleted_flag === API_FLAG.On
    ) {
      ccusSentStatus = CCUS_SENT_STATUS.unableToSend.id;
    } else if (
      inOutResult.ccus_send_status === CCUS_SENT_STATUS.notSentAfterChange.id &&
      inOutResult.ccus_jigyousya_deleted_flag === API_FLAG.On
    ) {
      ccusSentStatus = CCUS_SENT_STATUS.unableToSendAfterChange.id;
    }
    state.apiData.worker_types = [inOutResult.worker_type];
    state.apiData.ccus_send_status = ccusSentStatus;
    state.apiData.ccus_untargeted_reason = inOutResult.ccus_untargeted_reason;
    state.apiData.partner_ccus_seceded_warning =
      inOutResult.partner_ccus_seceded_warning;
    this.setState(state);

    if (inOutResult.worker_type === ENTRANCE_WORKER_TYPES.worker.id) {
      this.loadAssignedFieldTreeWorkersList(inOutResult);
    } else {
      state.editForm = InOutResultService.createEditForm(
        inOutResult,
        state.fieldSettings
      );
      state.editForm.isValid = true;
      state.editForm.errorList = {};
      // this.settingDisplayFieldTree(state, response.data.field_tree_worker);
      state.dialogStatus = DIALOG_STATUS.editDialogEnabled.id;
    }
  };

  /**
   * 入退場実績全承認ダイアログを表示する
   * */
  showApproveAllDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.approveAllDialogEnabled.id;
    this.setState(state);
  };

  /**
   * 入退場実績承認ダイアログを表示するか確認する
   * */
  showApproveDialogIfValid = () => {
    let state = { ...this.state };
    if (state.selectedUnapprovedCheckInOutLogList.length > 0) {
      state.dialogStatus = DIALOG_STATUS.approvedDialogEnabled.id;
    } else {
      state.failDialog.message = messageUtility.getMessage('W-002-001-001');
      state.failDialog.title = TITLE_NOT_CHOICE_RECORD;
      state.dialogStatus = DIALOG_STATUS.approveFailDialogEnabled.id;
    }
    this.setState(state);
  };

  /**
   * 入退場実績承認解除ダイアログを表示するか確認する
   * */
  showUnapprovedDialogIfValid = () => {
    let state = { ...this.state };
    if (state.selectedApproveCheckInOutLogList.length > 0) {
      state.dialogStatus = DIALOG_STATUS.unapprovedDialogEnabled.id;
    } else {
      state.failDialog.message = messageUtility.getMessage('W-002-001-004');
      state.failDialog.title = TITLE_NOT_CHOICE_RECORD;
      state.dialogStatus = DIALOG_STATUS.unapprovedFailDialogEnabled.id;
    }
    this.setState(state);
  };

  /**
   * 入退場者種別設定
   * */
  onChangeWorkerType = value => {
    const state = _.cloneDeep(this.state);
    const workerTypes = parseInt(value);

    state.editForm.workerId = null;
    state.editForm.workerName = '';
    state.editForm.fieldTreeWorkerId = '';
    state.editForm.spotCompanyName = '';
    state.editForm.primeCompanyName = '';
    state.editFormClearFlag = true;

    state.editForm.workerType = parseInt(value);
    state.apiData.spot_worker_name = '';
    if (workerTypes !== ENTRANCE_WORKER_TYPES.worker.id) {
      if (
        workerTypes === ENTRANCE_WORKER_TYPES.guest.id ||
        workerTypes === ENTRANCE_WORKER_TYPES.temporary.id
      ) {
        state.apiData.worker_types = [
          ENTRANCE_WORKER_TYPES.temporary.id,
          ENTRANCE_WORKER_TYPES.guest.id,
        ];
      } else {
        state.apiData.worker_types = [workerTypes];
      }
    }
    this.setState(state);
  };

  /**
   * 入退場実績CSV出力
   * */
  downloadCheckInOutCsv = () => {
    const state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    this.setState({ isLoading: true });
    InOutResultApi.fetchInOutCSV(
      state.fieldId,
      InOutResultService.createSearchInOutResult(
        state.infiniteScrollLoadSearchForm,
        state.spotFlg
      )
    )
      .then(result => {
        if (result instanceof Blob) {
          InOutResultService.downloadCsv(result, state.fieldId);
        } else {
          blobToJsonConversion(result.data)
            .then(blob => {
              state.failDialog.message = blob.message;
              state.errorDialogStatus =
                DIALOG_STATUS.downloadInOutResultCsvFailDialogEnabled.id;
            })
            .catch(() => {
              state.failDialog.message = messageUtility.getMessage('E-000-021');
              state.errorDialogStatus =
                DIALOG_STATUS.downloadInOutResultCsvFailDialogEnabled.id;
            })
            .finally(() => {
              this.setState(state);
            });
        }
      })
      .catch(error => {
        state.failDialog.message = extractErrorMessage(error);
        state.errorDialogStatus =
          DIALOG_STATUS.downloadInOutResultCsvFailDialogEnabled.id;
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * ダイアログのステータスを閉じるに設定する
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.failDialog.title = '';
    this.setState(state);
  };

  /**
   * エラーダイアログのステータスを閉じるに設定する
   * */
  closeErrorDialog = () => {
    let state = { ...this.state };
    state.errorDialogStatus = DIALOG_STATUS.disabled.id;
    this.setState(state);
  };

  /**
   * 追加・更新用プロパティの初期化
   * @param state
   * @returns state
   */
  clearEditFormInState = state => {
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.previousDialogStatus = false;
    state.editForm.workerType = 0;
    state.editForm.checkInOutLogId = '';
    state.editForm.fieldTreeWorkerId = '';
    state.editForm.workerId = '';
    state.editForm.workerName = '';
    state.editForm.recordingMethod = '';
    state.editForm.targetDate = '';
    state.editForm.inHour = DEFAULT_IN_OUT_RESULT_TIME.in.hour;
    state.editForm.inMin = DEFAULT_IN_OUT_RESULT_TIME.in.min;
    state.editForm.outHour = DEFAULT_IN_OUT_RESULT_TIME.out.hour;
    state.editForm.outMin = DEFAULT_IN_OUT_RESULT_TIME.out.min;
    state.editForm.nextFlg = 0;
    state.editForm.selectedOrder = null;
    state.editForm.selectedFieldTree = Object.create(null);
    state.editForm.isCompanySelectDialogShow = false;
    state.editForm.positionCode = '';
    state.editForm.positionName = '';
    state.editForm.categoryMajorCode = '';
    state.editForm.categoryMajorName = '';
    state.editForm.categoryMinorCode = '';
    state.editForm.categoryMinorName = '';
    state.editForm.workContent = '';
    state.editForm.displayFieldTree = '';
    state.editForm.bodyTemperature = '';
    state.editForm.manualBodyTemperature = '';
    state.editForm.remarks = '';
    state.editForm.manualUpdateUser = '';
    state.editForm.manualUpdateAt = '';
    state.editForm.isValid = true;
    state.editForm.errorList = {};
    state.fieldTreeList.length = 0;
    state.workerList.length = 0;
    return state;
  };

  /**
   * 入退場実績のリストとチェック済のリストを初期化する
   * @param state
   * @returns state
   */
  clearListInfo = state => {
    state.searchForm.total = 0;
    state.searchForm.offset = 0;
    state.infiniteScrollLoadSearchForm.total = 0;
    state.infiniteScrollLoadSearchForm.offset = 0;
    state.bodyTemperatureExists = 0;
    state.manualBodyTemperatureExists = 0;
    state.checkInOutLogList.length = 0;
    state.selectedApproveCheckInOutLogList.length = 0;
    state.selectedUnapprovedCheckInOutLogList.length = 0;
    state.canLoadMore = true;
    return state;
  };

  /**
   * 入場時刻・退場時刻の設定を変更した際に呼び出す
   * @param {string}propertyName:ステート内のプロパティ名
   * @param {string}item:選択された時刻
   * */
  setTime = (propertyName, item) => {
    let state = { ...this.state };
    state.editForm[propertyName] = Number(item);
    this.setState(state);
  };

  /**
   * 入退場実績追加・更新した際に呼び出す
   * @param {string} value 選択された手入力体温
   * */
  setManualBodyTemperature = value => {
    let state = { ...this.state };
    state.editForm.manualBodyTemperature = value;
    this.setState(state);
  };

  /**
   * 入退場実績追加・更新した際に呼び出す
   * @param {string} value 入力された備考
   * */
  setRemarks = value => {
    let state = { ...this.state };
    state.editForm.remarks = value;
    this.setState(state, this.validateEditForm);
  };

  /**
   * 施工体系情報を取得する
   * 一次会社 ＞ 二次会社 ＞ 三次会社 ＞ 四次会社 ＞ 五次会社
   * @param field_tree
   * @return 加工した施工体系情報
   * */
  displayFieldTreeRoute = field_tree => {
    let list = [];
    for (let index = 1; index <= 5; index++) {
      if (isNullOrEmpty(field_tree[`company_tree_name_${index}`])) {
        break;
      }
      list.push(field_tree[`company_tree_name_${index}`]);
    }
    return list.join(' ＞ ');
  };

  /**
   * 会社名を取得する
   * 一次会社(所属会社)フォーマット
   * @param field_tree
   * @return 加工した会社名
   * */
  displayCompanyNameWithPrimary = field_tree => {
    // 所属会社が一次会社の場合は会社名をそのまま返却
    // それ以外は一次会社(所属会社)フォーマットで返却
    if (
      field_tree.company_tree_name_1 === field_tree.company_name &&
      _.isEmpty(field_tree.company_tree_name_2)
    ) {
      return field_tree.company_name;
    } else {
      return `${field_tree.company_tree_name_1}(${field_tree.company_name})`;
    }
  };

  /**
   * 入退場実績を取得する
   * */
  loadCheckInOutResultList = () => {
    const preSearchForm = _.cloneDeep(this.state.searchForm);
    const state = _.cloneDeep(this.state);
    if (this.state.isLoading) {
      return;
    }

    state.isLoading = true;
    state.lastRequestWithTemperature = this.state.searchForm.bodyTemperatureEnabled;
    this.setState(state);

    InOutResultApi.fetchInOutResultList(
      this.state.fieldId,
      InOutResultService.createSearchInOutResult(
        this.state.infiniteScrollLoadSearchForm,
        this.state.spotFlg
      )
    )
      .then(response => {
        if (response.result) {
          if (
            !InOutResultService.isSameSearchForm(
              preSearchForm,
              this.state.searchForm
            )
          ) {
            /*
             * NOTE:
             * 期間の矢印の連打などで入退場実績の取得前後で検索条件が変わっていることがある
             * このような場合は後の検索条件(画面に表示されている検索条件)での実績検索はisLoadingがtrueのためスキップされている
             * そのため後の検索条件で再度入退場実績の取得を行う必要があり、setTimeoutで再度loadCheckInOutResultListを呼び出している。
             * */
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.loadCheckInOutResultList();
            });
          } else {
            state.searchForm.total = response.data.total;
            state.infiniteScrollLoadSearchForm.total = response.data.total;
            state.bodyTemperatureExists =
              response.data.entities.body_temperature_exists;
            response.data.entities.check_in_out_logs
              .filter(
                item => !state.checkInOutLogList.some(log => log.id === item.id)
              )
              .forEach(item => state.checkInOutLogList.push(item));
            state.manualBodyTemperatureExists = state.checkInOutLogList.some(
              log => !isNullOrEmpty(log.manual_body_temperature)
            );
            if (state.checkInOutLogList.length > 0) {
              state.searchForm.offset = state.checkInOutLogList.length;
              state.infiniteScrollLoadSearchForm.offset =
                state.checkInOutLogList.length;
            }
            this.setState(state);
          }
        } else {
          this.invokeError(response);
        }
      })
      .catch(error => {
        this.invokeError(error);
      })
      .finally(() => {
        const { checkInOutLogList, searchForm } = state;
        state.isLoading = false;
        state.canLoadMore = _.size(checkInOutLogList) < searchForm.total;
        this.setState(state);
      });
  };

  /**
   * 現場に割当済の技能者一覧を取得する
   * */
  loadAssignedWorker = fieldTreeId => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    FieldTreeWorkersApi.getAssignedWorker(fieldTreeId, null)
      .then(response => {
        if (response.result) {
          state.workerList = response.data.entities.assigned_workers;
          if (state.workerList.length > 0) {
            state.editForm.fieldTreeWorkerId =
              state.workerList[0].field_tree_worker_id;
          }
        } else {
          //通信エラーメッセージ用ダイアログ
          state.failDialog.message = extractErrorMessage(response);
          state.errorDialogStatus = DIALOG_STATUS.networkErrorDialogEnabled.id;
        }
      })
      .catch(error => {
        //通信エラーメッセージ用ダイアログ
        state.failDialog.message = extractErrorMessage(error);
        state.errorDialogStatus = DIALOG_STATUS.networkErrorDialogEnabled.id;
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
        // 労務安全利用かつfie
        this.settingWorkerContent(state);
      });
  };

  /**
   * 作業員選択イベント
   * @param {object}worker
   */
  selectWorker = worker => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.fetchAssignedFieldTreeWorkersList(
      state.fieldId,
      worker.worker_id,
      { use_ccus_engineer_id: USE_CCUS_ENGINEER_ID.use.id }
    )
      .then(response => {
        if (response.result === true) {
          state.workerSelectDialog.selectWorkerName = `${worker.name_sei} ${worker.name_mei}`;
          state.workerSelectDialog.selectWorkerId = worker.entrance_worker_id;
          if (response.data.total > 1) {
            _.map(
              response.data.entities.field_tree_workers,
              field_tree_worker => {
                state.fieldTreeList.push(field_tree_worker);
              }
            );
            state.dialogStatus = DIALOG_STATUS.isFieldTreeSelectDialogShow.id;
          } else {
            this.changeWorker(response.data.entities.field_tree_workers[0]);
            state.dialogStatus = state.previousDialogStatus;
          }
        } else {
          state.errorDialogStatus =
            DIALOG_STATUS.selectWorkerFailDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
          state.isLoading = false;
          this.setState(state);
          this.searchWorkerList();
        }
      })
      .catch(error => {
        state.errorDialogStatus =
          DIALOG_STATUS.selectWorkerFailDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        state.isLoading = false;
        this.setState(state);
        this.searchWorkerList();
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 作業員の紐づく協力会社現場を取得する
   * */
  loadAssignedFieldTreeWorkersList = inOutResult => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.fetchAssignedFieldTreeWorker(
      state.fieldId,
      inOutResult.worker_id,
      inOutResult.field_tree_worker_id
    )
      .then(response => {
        if (response.result === true) {
          state.editForm = InOutResultService.createEditForm(
            inOutResult,
            state.fieldSettings
          );
          state.editForm.isValid = true;
          state.editForm.errorList = {};
          this.settingDisplayFieldTree(state, response.data.field_tree_worker);
          state.dialogStatus = DIALOG_STATUS.editDialogEnabled.id;
        } else {
          state.dialogStatus = DIALOG_STATUS.uploadFailDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
        }
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.uploadFailDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
      })
      .finally(() => {
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 施工体系リストを設定する
   * */
  settingDisplayFieldTree = (state, field_tree_worker) => {
    state.editForm.displayFieldTree = this.displayFieldTreeRoute(
      field_tree_worker
    );
    this.setState(state);
  };

  /**
   * 入退場実績を登録する
   * */
  registerCheckInOutResult = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    if (!InOutResultService.isOutTimeSameOrLaterThanInTime(state.editForm)) {
      alert(messageUtility.getMessage('W-002-001-003'));
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.registerInOutResult(
      state.fieldId,
      InOutResultService.createRegisterInOutResult(state.editForm)
    )
      .then(response => {
        if (response.result) {
          state.isLoading = false;
          this.clearListInfo(state);
          this.setState(state);
          this.closeEditDialog();
          this.loadCheckInOutResultList();
        } else {
          state.dialogStatus = DIALOG_STATUS.uploadFailDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
          state.isLoading = false;
          this.setState(state);
        }
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.uploadFailDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 入退場実績を削除する
   * */
  deleteCheckInOutResultList = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.deleteInOutResult(
      state.fieldId,
      InOutResultService.createDeleteList(
        _.unionWith(
          state.selectedApproveCheckInOutLogList,
          state.selectedUnapprovedCheckInOutLogList,
          _.isEqual
        )
      )
    )
      .then(response => {
        if (response.result) {
          state.isLoading = false;
          state = this.clearListInfo(state);
          state.dialogStatus = DIALOG_STATUS.disabled.id;
          this.setState(state);
        } else {
          state.isLoading = false;
          state.dialogStatus = DIALOG_STATUS.deleteErrorDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
          this.setState(state);
        }
      })
      .catch(error => {
        state.isLoading = false;
        state.dialogStatus = DIALOG_STATUS.deleteErrorDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        this.setState(state);
      })
      .finally(() => {
        this.clearSearchProperty('searchForm');
        this.clearSearchProperty('infiniteScrollLoadSearchForm');
        this.loadCheckInOutResultList();
      });
  };

  /**
   * 入退場実績を全件承認する
   * */
  approveAllCheckInOutResult = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.updateInOutResultAllApprove(state.fieldId)
      .then(response => {
        if (response.result) {
          state.isLoading = false;
          state = this.clearListInfo(state);
          state.dialogStatus = DIALOG_STATUS.disabled.id;
          this.setState(state);
          this.clearSearchProperty('searchForm');
          this.clearSearchProperty('infiniteScrollLoadSearchForm');
          this.loadCheckInOutResultList();
        } else {
          state.isLoading = false;
          state.dialogStatus = DIALOG_STATUS.approveAllFailDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
          state.failDialog.title = '変更可能な項目がありません';
          this.setState(state);
        }
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.approveAllFailDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * 入退場実績を承認する
   * */
  approveCheckInOutResultList = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.updateInOutResultApprove(
      state.fieldId,
      InOutResultService.createApproveList(
        state.selectedUnapprovedCheckInOutLogList
      )
    )
      .then(response => {
        state = this.clearListInfo(state);
        if (response.result) {
          state.dialogStatus = DIALOG_STATUS.disabled.id;
        } else {
          state.dialogStatus = DIALOG_STATUS.approveFailDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
        }
        state.isLoading = false;
        this.setState(state);
        this.clearSearchProperty('searchForm');
        this.clearSearchProperty('infiniteScrollLoadSearchForm');
        this.loadCheckInOutResultList();
      })
      .catch(error => {
        state.isLoading = false;
        state.dialogStatus = DIALOG_STATUS.approveFailDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        this.setState(state);
      });
  };

  /**
   * 入退場実績を承認解除する
   * */
  unApprovedCheckInOutResultList = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.updateInOutResultUnapproved(
      state.fieldId,
      InOutResultService.createUnapprovedList(
        state.selectedApproveCheckInOutLogList
      )
    )
      .then(response => {
        state = this.clearListInfo(state);
        if (response.result) {
          state.dialogStatus = DIALOG_STATUS.disabled.id;
        } else {
          state.dialogStatus = DIALOG_STATUS.cancelApproveFailDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
        }
        state.isLoading = false;
        this.setState(state);
        this.clearSearchProperty('searchForm');
        this.clearSearchProperty('infiniteScrollLoadSearchForm');
        this.loadCheckInOutResultList();
      })
      .catch(error => {
        state.isLoading = false;
        state.dialogStatus = DIALOG_STATUS.cancelApproveFailDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        this.setState(state);
      });
  };

  /**
   * 入退場実績を更新する
   * */
  updateCheckInOutResult = () => {
    let state = { ...this.state };
    if (state.isLoading) {
      return;
    }

    if (!InOutResultService.isOutTimeSameOrLaterThanInTime(state.editForm)) {
      alert(messageUtility.getMessage('W-002-001-003'));
      return;
    }

    state.isLoading = true;
    this.setState(state);
    InOutResultApi.updateInOutResult(
      state.fieldId,
      state.editForm.checkInOutLogId,
      InOutResultService.createUpdateInOutResult(state.editForm)
    )
      .then(response => {
        this.clearListInfo(state);
        this.closeEditDialog();
        if (response.result !== true) {
          state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
        } else {
          state.dialogStatus = DIALOG_STATUS.disabled.id;
        }
        state.isLoading = false;
        this.setState(state);
        this.loadCheckInOutResultList();
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
        state.isLoading = false;
        this.setState(state);
      });
  };

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  componentDidMount() {
    let state = { ...this.state };

    state.fieldId = SessionStorageService.getFieldId();
    if (isNullOrEmpty(state.fieldId)) {
      state.isShowNotExistFieldIdDialog = true;
      this.setState(state);
      return;
    }

    // 検索条件期間に今日の日付を設定する。
    const today = moment().format(DATE_TIME_FORMAT.slashDateFormat);
    state.searchForm.fromDate = today;
    state.searchForm.toDate = today;
    this.setState(state);

    // 現場設定情報取得
    FieldSettingsApi.fetchCheckInOutSettings(state.fieldId)
      .then(response => {
        if (response.result) {
          state.fieldSettings = response.data.entities.check_in_out_setting;
          state.fieldSettings.recording_method = Number(
            state.fieldSettings.recording_method
          );
          if (state.isPrimeContractor && state.fieldSettings.spot_flg === 1) {
            state.spotFlg = true;
          } else {
            state.spotFlg = false;
            state.editForm.workerType = ENTRANCE_WORKER_TYPES.worker.id;
          }
          state.searchForm.bodyTemperature =
            state.fieldSettings.body_temperature_threshold;
        } else {
          state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
          state.failDialog.message = extractErrorMessage(response);
        }
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
        state.failDialog.message = extractErrorMessage(error);
      })
      .finally(() => {
        state.searchForm.workerTypesList = _.map(
          ENTRANCE_WORKER_TYPES,
          item => {
            if (
              state.spotFlg ||
              (!state.spotFlg && item.id === ENTRANCE_WORKER_TYPES.worker.id)
            ) {
              return item;
            }
          }
        );
        this.setState({
          lastRequestWithTemperature: this.state.searchForm
            .bodyTemperatureEnabled,
        });
        state.searchForm.entranceExitRecordStatus = _.map(
          ENTRANCE_EXIT_RECORD_STATUS,
          item => item
        );
        state.infiniteScrollLoadSearchForm = _.cloneDeep(state.searchForm);
        // 入退場実績一覧取得
        InOutResultApi.fetchInOutResultList(
          state.fieldId,
          InOutResultService.createSearchInOutResult(
            state.searchForm,
            state.spotFlg
          )
        )
          .then(response => {
            if (response.result) {
              state.searchForm.total = response.data.total;
              state.infiniteScrollLoadSearchForm.total = response.data.total;
              state.bodyTemperatureExists =
                response.data.entities.body_temperature_exists;
              state.checkInOutLogList =
                response.data.entities.check_in_out_logs;
              state.manualBodyTemperatureExists = state.checkInOutLogList.some(
                log => !isNullOrEmpty(log.manual_body_temperature)
              );
              if (state.checkInOutLogList.length > 0) {
                state.searchForm.offset = state.checkInOutLogList.length;
                state.infiniteScrollLoadSearchForm.offset = state.checkInOutLogList.length;
              }
            } else {
              state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
              state.failDialog.message = extractErrorMessage(response);
            }
          })
          .catch(error => {
            state.dialogStatus = DIALOG_STATUS.updateErrorDialogEnabled.id;
            state.failDialog.message = extractErrorMessage(error);
          })
          .finally(() => {
            InOutResultApi.fetchMainJvSecededCcus(state.fieldId)
              .then(response => {
                state.ccusSecededWarning = _.get(
                  response,
                  'data.entities.ccus_seceded_warning'
                );
                state.jvFlag = _.get(
                  response,
                  'data.entities.sub_jv_exists_flag'
                );
              })
              .finally(() => {
                state.isLoading = false;
                this.setState(state);
              });
          });
      });

    //入力データの規則を定義
    this.editFormValidationScheme = Joi.object().keys({
      // 備考
      // 最大30文字
      // ブランクを許可
      remarks: Joi.string()
        .max(30)
        .allow(null, ''),
    });
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevState.editFormClearFlag) {
      this.setState({
        editFormClearFlag: false,
      });
    }
  }

  /**
   * React Component LifeCycle
   * コンポーネントが更新されたときに DOM を操作する機会に使用する
   * */
  componentDidUpdate() {
    DocumentDelegate.init();
    this.FormCalendar = new DropdownCalendarLoader();
    this.FormCalendar.constructerQuery = data.calendarClassName;
    this.FormCalendar.init(DocumentDelegate, (event, name, value) => {
      let state = _.cloneDeep(this.state);
      if (name.includes('.')) {
        // editForm.targetDate etc... で送られてくる
        const nameArray = name.split('.');
        if (nameArray[0] === 'searchForm') {
          this.changeSearchDate(nameArray[1], value);
          return;
        }

        state[nameArray[0]][nameArray[1]] = value;
      } else {
        state[name] = value;
      }
      this.setState(state);
    });
    if (this.state.searchForm.clearFlag === true) {
      let stateVal = _.cloneDeep(this.state);
      stateVal.searchForm.clearFlag = false;
      this.setState(stateVal);
    }
  }

  render() {
    return (
      <InOutResultContext.Provider
        value={{
          state: this.state,
          closeNotExistFieldIdDialog: this.closeNotExistFieldIdDialog,
          searchFormHandle: this.searchFormHandle,
          selectedApprovedStatus: this.selectedApprovedStatus,
          selectedFieldTreeIds: this.selectedFieldTreeIds,
          selectedWorker: this.selectedWorker,
          selectedBodyTemperatureEnabled: this.selectedBodyTemperatureEnabled,
          selectedBodyTemperature: this.selectedBodyTemperature,
          selectedPriorCcusError: this.selectedPriorCcusError,
          inputWorkerName: this.inputWorkerName,
          selectedSentStatus: this.selectedSentStatus,
          clearSearchProperty: this.clearSearchProperty,
          infiniteScrollLoad: this.infiniteScrollLoad,
          checkSingleTableData: this.checkSingleTableData,
          checkSingleSearchData: this.checkSingleSearchData,
          changeSort: this.changeSort,
          toggle: this.toggle,
          changeSelectedOrder: this.changeSelectedOrder,
          selectedFieldTree: this.selectedFieldTree,
          changeWorker: this.changeWorker,
          settingWorkerContent: this.settingWorkerContent,
          changeEditFormFieldTreeWorker: this.changeEditFormFieldTreeWorker,
          changeWorkerName: this.changeWorkerName,
          selectFieldTree: this.selectFieldTree,
          showAddDialog: this.showAddDialog,
          showSelectWorkerDialog: this.showSelectWorkerDialog,
          closeWorkerSelectDialog: this.closeWorkerSelectDialog,
          backWorkerSelectDialog: this.backWorkerSelectDialog,
          closeEditDialog: this.closeEditDialog,
          showDeleteDialogIfValid: this.showDeleteDialogIfValid,
          showEditDialog: this.showEditDialog,
          showApproveAllDialog: this.showApproveAllDialog,
          showApproveDialogIfValid: this.showApproveDialogIfValid,
          showUnapprovedDialogIfValid: this.showUnapprovedDialogIfValid,
          onChangeWorkerType: this.onChangeWorkerType,
          downloadCheckInOutCsv: this.downloadCheckInOutCsv,
          closeDialog: this.closeDialog,
          closeErrorDialog: this.closeErrorDialog,
          setTime: this.setTime,
          deleteCheckInOutResultList: this.deleteCheckInOutResultList,
          approveAllCheckInOutResult: this.approveAllCheckInOutResult,
          approveCheckInOutResultList: this.approveCheckInOutResultList,
          unApprovedCheckInOutResultList: this.unApprovedCheckInOutResultList,
          updateCheckInOutResult: this.updateCheckInOutResult,
          registerCheckInOutResult: this.registerCheckInOutResult,
          searchWorkerList: this.searchWorkerList,
          selectWorker: this.selectWorker,
          displayFieldTreeRoute: this.displayFieldTreeRoute,
          displayCompanyNameWithPrimary: this.displayCompanyNameWithPrimary,
          clearWorkerSelectSearchData: this.clearWorkerSelectSearchData,
          doSearch: this.doSearch,
          setManualBodyTemperature: this.setManualBodyTemperature,
          setRemarks: this.setRemarks,
          selectCompanyIds: this.selectCompanyIds,
          checkSingleData: this.checkSingleData,
        }}
      >
        {this.props.children}
      </InOutResultContext.Provider>
    );
  }
}

const data = {
  calendarClassName: '.sys-form-calender',
  fieldTree: [
    { index: 0, label: '1次' },
    { index: 1, label: '2次' },
    { index: 2, label: '3次' },
    { index: 3, label: '4次' },
    { index: 4, label: '5次' },
  ],
  initialFieldId: 0,
  initialOrder: 0,
  limitOrder: 4,
};



// WEBPACK FOOTER //
// ./src/services/inOutResult/InOutResultStore.js